import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const PlayButtonContainer = styled.div`
  position: absolute;
  z-index: 1000;
`

export const SlideContainer = styled.div`
  align-items: center;
  flex-direction: row;
  padding: 0;
  overflow: hidden;
  .centered {
    align-items: center;
  }
`

export const RepRow = styled.div`
  font-family: "Avenir", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  color: ${color.copy[800]};
  .company-name-thin {
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
  }
  .bold-rep {
    font-size: 14px;
    font-weight: 900;
  }
`

export const VideoCol = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin-bottom: 24px;
  width: 100%;
  @media (min-width: 993px) {
    margin-bottom: 0px;
  }
  .img-play-btn {
    cursor: pointer;
  }
  .thumbnail-img {
    width: 100%;
    max-width: 570px;
    height: auto;
    object-fit: cover;
    border-radius: 12px;
    aspect-ratio: 16/9;
    @media (min-width: 769px) {
      max-width: 570px;
    }
    @media (min-width: 1241px) {
      max-width: unset;
      width: 770px;
    }
  }
`

export const SlideRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  max-height: 567px;
  max-width: 506px;
  gap: 30px;
  margin: 0 auto;
  @media (min-width: 769px) {
    max-width: 570px;
    max-height: 100%;
  }
  @media (min-width: 993px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 1170px;
    margin: 64px 0;
  }
  .testimonial-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 506px;
    margin: 16px 0;

    @media (min-width: 769px) {
      max-width: 770px;
    }
    @media (max-width: 993px) {
      max-width: 1170px;
    }
  }
  .testimonial-text {
    font-weight: 800;
    font-family: "Avenir", sans-serif;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
    color: ${color.oxfordBlue[800]};
    @media (min-width: 993px) {
      max-width: 360px;
    }
  }
`
